import { useRef } from "react"
import { useNavigate } from "react-router-dom"

import Style from "./style"

import DefaultButton from "shared/ui/DefaultButton"
import ContactInput from "widget/ContactInput"

import useGetAccountId from "entity/auth/useGetAuthId"

const FindId = () => {
    const navigate = useNavigate()

    const countryCodeRef = useRef()
    const contactRef = useRef()

    const [accountId, getAccountIdEvent] = useGetAccountId()

    return (
        <Style.Wrapper>
            <Style.Title>FORGOT ID</Style.Title>

            <Style.Form>
                <ContactInput countryCodeRef={countryCodeRef} contactRef={contactRef} />
            </Style.Form>

            {accountId?.statusCode === 200 && <Style.Result>고객님의 아이디는 <span>{accountId?.data?.id}</span> 입니다.</Style.Result>}

            <Style.ButtonDiv>
                <DefaultButton clickEvent={getAccountIdEvent}>아이디 찾기</DefaultButton>
            </Style.ButtonDiv>

            <Style.movePageButton onClick={() => navigate("/find/password")}>비밀번호 찾기</Style.movePageButton>

        </Style.Wrapper>
    )
}

export default FindId